"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Error codes for use during proof construction
 */
var codes = {
  BAD_BLINDING_FACTOR: 'BAD_BLINDING_FACTOR',
  BAD_K: 'BAD_K',
  BALANCING_RELATION_NOT_SATISFIED: 'BALANCING_RELATION_NOT_SATISFIED',
  CHALLENGE_RESPONSE_FAIL: 'CHALLENGE_RESPONSE_FAIL',
  EPOCH_DOES_NOT_EXIST: 'EPOCH_DOES_NOT_EXIST',
  GAMMA_IS_INFINITY: 'GAMMA_IS_INFINTY',
  GAMMA_SIGMA_NOT_ON_CURVE: 'GAMMA_SIGMA_NOT_ON_CURVE',
  INCORRECT_NOTE_NUMBER: 'INCORRECT_NOTE_NUMBER',
  KA_TOO_BIG: 'KA_TOO_BIG',
  KB_TOO_BIG: 'KB_TOO_BIG',
  KPUBLIC_MALFORMED: 'KPUBLIC_MALFORMED',
  M_TOO_BIG: 'M_TOO_BIG',
  NO_ADD_CHALLENGEVAR: 'NO_ADD_CHALLENGEVAR',
  NO_CONTRACT_ADDRESS: 'NO_CONTRACT_ADDRESS',
  NO_CONTRACT_ADDRESSES: 'NO_CONTRACT_ADDRESSES',
  NO_CONTRACT_ARTIFACT: 'NO_CONTRACT_ARTIFACT',
  NOT_ON_CURVE: 'NOT_ON_CURVE',
  NOTE_VALUE_TOO_BIG: 'NOTE_VALUE_TOO_BIG',
  POINT_AT_INFINITY: 'POINT_AT_INFINITY',
  SCALAR_IS_ZERO: 'SCALAR_IS_ZERO',
  SCALAR_TOO_BIG: 'SCALAR_TOO_BIG',
  SHOULD_THROW_IS_UNDEFINED: 'SHOULD_THROW_IS_UNDEFINED',
  SIGMA_IS_INFINTY: 'SIGMA_IS_INFINITY',
  UNSUPPORTED_NETWORK: 'UNSUPPORTED_NETWORK',
  VIEWING_KEY_MALFORMED: 'VIEWING_KEY_MALFORMED',
  X_TOO_BIG: 'X_TOO_BIG',
  Y_TOO_BIG: 'Y_TOO_BIG',
  ZA_TOO_BIG: 'ZA_TOO_BIG',
  ZB_TOO_BIG: 'ZB_TOO_BIG'
};
/**
 * Take in the error to be thrown, throw it and return additional debugging
 * information alongside
 *
 * @class AztecError
 * @param {string} code - the code of the error thrown
 * @param {Object} data - additional debugging information to be thrown alongside the
 * error
 */

var AztecError = /*#__PURE__*/function (_Error) {
  _inherits(AztecError, _Error);

  function AztecError(code, data) {
    var _this;

    _classCallCheck(this, AztecError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AztecError).call(this, code));
    _this.data = data;
    return _this;
  }

  return AztecError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = {
  AztecError: AztecError,
  codes: codes
};